import React from 'react';
import { useIntl } from 'react-intl';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components';
import TimelineView from './View';
import TimelineEditSchema from './EditSchema';

const Edit = (props) => {
  const { data = {}, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = TimelineEditSchema({ intl });

  const onChangeField = (id, value) => {
    onChangeBlock(block, {
      ...data,
      [id]: value,
    });
  };

  const onChangeForm = (newData) => {
    onChangeBlock(block, {
      ...data,
      ...newData,
    });
  };

  return (
    <>
      <div className="block fcmh-timeline-block">
        <TimelineView {...props} mode="edit" />
      </div>

      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          onChangeField={onChangeField}
          onChangeForm={onChangeForm}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
